import Reveal from 'reveal.js';

import Markdown from 'reveal.js/plugin/markdown';

import Highlight from 'reveal.js/plugin/highlight';

import Notes from 'reveal.js/plugin/notes';

import './styles/main.css';

import s01 from './slides/s01-intro.html?raw';

import s02 from './slides/s02-team.html?raw';

import s03 from './slides/s03-rd.html?raw';

import s04 from './slides/s04-lore.html?raw';

import s05 from './slides/s05-fundamenty-koszmaru.html?raw';

import s06 from './slides/s06-architektura.html?raw';

import s07 from './slides/s07-inspiracje.html?raw';

import s08 from './slides/s08-pipeline.html?raw';

import s09 from './slides/s09-level-unreal.html?raw';

import s10 from './slides/s10-dwie-wizje.html?raw';

import s11 from './slides/s11-rezyseria.html?raw';

import s12 from './slides/s12-strach.html?raw';

import s13 from './slides/s13-field-recording.html?raw';

import s14 from './slides/s14-audio.html?raw';

import s15 from './slides/s15-muzyka.html?raw';

import s16 from './slides/s16-muzyka-lore.html?raw';

import s17 from './slides/s17-estetyka.html?raw';

import s18 from './slides/s18-plany.html?raw';

import s19 from './slides/s19-core-team.html?raw';

import s20 from './slides/s20-qanda.html?raw';

const slidesContainer = document.querySelector('.slides');

if (slidesContainer) {
  slidesContainer.innerHTML = [
    s01,
    s02,
    s03,
    s04,
    s05,
    s06,
    s07,
    s08,
    s09,
    s10,
    s11,
    s12,
    s13,
    s14,
    s15,
    s16,
    s17,
    s18,
    s19,
    s20,
  ].join('\n');

  injectPresenterNotes(slidesContainer);
}

/** Kontener notatek na każdym slajdzie liściowym (widoczny tylko w widoku prezentera, klawisz S). */
function injectPresenterNotes(container: Element): void {
  for (const slide of container.querySelectorAll('section')) {
    if (slide.querySelector(':scope > section')) continue;
    if (slide.querySelector('aside.notes')) continue;

    const aside = document.createElement('aside');
    aside.className = 'notes';

    const notesList = document.createElement('ol');
    notesList.className = 'nl-notes';
    aside.append(notesList);

    slide.append(aside);
  }
}

const deck = new Reveal({
  hash: true,

  slideNumber: true,

  transition: 'slide',

  navigationMode: 'linear',

  plugins: [Markdown, Highlight, Notes],
});

/** Kopiuje data-video-dim ze slajdu na powiązane .slide-background (bez :has() - brak migania przy przejściu). */
const VIDEO_DIM_LEVELS = new Set(['super-extra-low', 'super-low', 'low', 'medium', 'strong']);

function syncVideoDimBackgrounds(): void {
  const slides = deck.getRevealElement()?.querySelectorAll<HTMLElement>('.slides section');
  if (!slides) return;

  for (const slide of slides) {
    const bg = deck.getSlideBackground(slide) as HTMLElement | undefined;
    if (!bg) continue;

    if (slide.classList.contains('nl-slide--video-dim')) {
      const level = slide.dataset.videoDim ?? 'medium';
      bg.dataset.videoDim = VIDEO_DIM_LEVELS.has(level) ? level : 'medium';
    } else {
      delete bg.dataset.videoDim;
    }
  }
}

void deck.initialize().then(() => {
  syncVideoDimBackgrounds();
});
